var render = function render(){
  var _vm$alarm$deviceName, _vm$alarm$locationNam, _vm$alarmSourceTitle;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content alarm-detail"
  }, [_c('button', {
    staticClass: "alarm-detail-back",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-chevron-left"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("notifications.back")))])]), _c('div', {
    class: `alarm-detail-title-row ${_vm.levelVariantText(_vm.alarm.level)}`
  }, [_c('h4', {
    staticClass: "alarm-detail-title"
  }, [_vm._v(" " + _vm._s(_vm.alarmTypeTitle(_vm.alarm.type)) + " ")]), _c('AlarmLevelIcon', {
    attrs: {
      "level": _vm.alarm.level,
      "large": ""
    }
  })], 1), _c('h6', {
    staticClass: "alarm-detail-section-title"
  }, [_vm._v(_vm._s(_vm.$t("notifications.alarm_time")))]), _c('div', {
    staticClass: "alarm-detail-field d-flex justify-content-between"
  }, [_c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.alarm.conditionStartedAt, false)))])]), _c('h6', {
    staticClass: "alarm-detail-section-title"
  }, [_vm._v(_vm._s(_vm.$t("notifications.alarm_description")))]), _c('p', {
    staticClass: "alarm-detail-text"
  }, [_vm._v(_vm._s(_vm.alarmTypeDescription(_vm.alarm.type)))]), _vm.alarmTypeFix(_vm.alarm.type) ? [_c('h6', {
    staticClass: "alarm-detail-section-title"
  }, [_vm._v(_vm._s(_vm.$t("notifications.how_to_fix")))]), _c('div', {
    staticClass: "alarm-fix-box d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa-solid fa-wrench mr-3"
  }), _c('span', [_vm._v(_vm._s(_vm.alarmTypeFix(_vm.alarm.type)))])])] : _vm._e(), _vm.alarm.deviceName || _vm.alarm.locationName || _vm.alarm.source ? _c('h6', {
    staticClass: "alarm-detail-section-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.details")) + " ")]) : _vm._e(), _vm.alarm.deviceName ? _c('div', {
    staticClass: "alarm-detail-field d-flex justify-content-between"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("notifications.device_name")))]), _c('span', {
    staticClass: "alarm-detail-field-value"
  }, [_vm._v(_vm._s((_vm$alarm$deviceName = _vm.alarm.deviceName) !== null && _vm$alarm$deviceName !== void 0 ? _vm$alarm$deviceName : "-"))])]) : _vm._e(), _vm.alarm.locationName ? _c('div', {
    staticClass: "alarm-detail-field d-flex justify-content-between"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("notifications.location")))]), _c('span', {
    staticClass: "alarm-detail-field-value"
  }, [_vm._v(_vm._s((_vm$alarm$locationNam = _vm.alarm.locationName) !== null && _vm$alarm$locationNam !== void 0 ? _vm$alarm$locationNam : "–"))])]) : _vm._e(), _vm.alarm.source ? _c('div', {
    staticClass: "alarm-detail-field d-flex justify-content-between"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("notifications.source")))]), _c('span', {
    staticClass: "alarm-detail-field-value"
  }, [_vm._v(_vm._s((_vm$alarmSourceTitle = _vm.alarmSourceTitle(_vm.alarm.source)) !== null && _vm$alarmSourceTitle !== void 0 ? _vm$alarmSourceTitle : "-"))])]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }